import { regionalConfig } from "./regional";
import { setI18nLocale } from "../plugins/i18n";
import { setVuetifyLocale } from "../plugins/vuetify";
import { loadDayjsLocale } from "../plugins/dayjs";

function determineLocale(): string {
  const urlParams = new URLSearchParams(window.location.search);
  const locale =
    urlParams.get("culture") ||
    sessionStorage.getItem("culture") ||
    regionalConfig.defaultLocale ||
    "en";
  return locale;
}

export const locale = determineLocale();

export function setGlobalLocale(newLocale: string): void {
  document.documentElement.lang = newLocale;
  setI18nLocale(newLocale);
  setVuetifyLocale(newLocale);
  loadDayjsLocale(newLocale);
}

declare global {
  interface Window {
    setGlobalLocale?: (newLocale: string) => void;
  }
}
window.setGlobalLocale = setGlobalLocale;
